import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import NotFoundPage from '@/app/NotFoundPage';
import MainPage from '@/features/home/MainPage';
import Reports from '@/features/reports/ReportsPage';
import Report from '@/features/report-detail/ReportDetailPage';
import { INTEGRATION_CLIENTS } from '@/shared/config/constants';
import { useSubscription } from '@/shared/hooks/useSubscription'
import Home from '@/features/home/HomePage';
import ForgotPass from '@/features/auth/pages/ForgotPass';
import SignUp from '@/features/auth/pages/SignUp';
import VerifyPass from '@/features/auth/pages/VerifyPass';
import Profile from '@/features/profile/ProfilePage';
import { useGetToolsQuery } from '@/api/rtk/toolsApi'
import Loader from '@/shared/components/Loader';
import Integration from '@/features/integration/IntegrationPage';

const AUTH_PATHS = ['/reset-password', '/sign-up', '/verify-password', '/login'];

export { AUTH_PATHS };

const AppRoutes = () => {
  const { trialEnded } = useSubscription();
  const userId = localStorage.getItem('user_id') || "";
  const location = useLocation();
  const { data: toolsData } = useGetToolsQuery(undefined, {
    skip: !userId || location.pathname.includes('/integration'),
  });
  const tools = toolsData?.tools || [];
  const integrationRoute = location.pathname.includes('/integration');
  const notIncludesAuthRoutes = !AUTH_PATHS.includes(location.pathname);
  const isLoadingTools =
    !trialEnded &&
    !!userId &&
    !tools?.length &&
    location.pathname !== '/' &&
    notIncludesAuthRoutes &&
    !integrationRoute;

  const locked = (element) =>
    trialEnded ? <Navigate to="/" replace /> : element;

  if (isLoadingTools) {
    return (
      <div className='w-full h-screen flex justify-center items-center'>
        <Loader/>
      </div>
    );
  }

  return (
    <Routes>
      {tools?.map((tool) => {
        const word = tool.name.split(' ')[0].toLowerCase();
        return (
          <Route
            key={tool.name}
            path={`/${word}`}
            element={locked(<Reports />)}
          />
        );
      })}
      {tools?.map((tool) => {
        const word = tool.name.split(' ')[0].toLowerCase();
        return (
          <Route
            key={`${word}-detail`}
            path={`/${word}/:id`}
            element={locked(<Report />)}
          />
        );
      })}
      {INTEGRATION_CLIENTS.map((client) => (
        <Route
          key={client}
          path={`/integration/${client}/:patientId`}
          element={locked(<Integration client={client} />)}
        />
      ))}
      <Route path='/' element={userId ? <Home/> : <MainPage/>} />
      <Route path='/settings' element={locked(<Profile/>)} />
      <Route path='/reset-password' element={userId ? <Navigate to={'/'}/> :<ForgotPass/>}/>
      <Route path='/login' element={userId ? <Navigate to={'/'} /> : <SignUp/>}/>
      <Route path='/sign-up' element={userId ? <Navigate to={'/'} /> : <SignUp/>}/>
      <Route path='/verify-password' element={userId ? <Navigate to={'/'}/> : <VerifyPass/>}/>
      <Route path='*' element={trialEnded ? <Navigate to="/" replace /> : <NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
